import { GoogleAuthProvider } from "firebase/auth";

/** Admin (StoryWorm-staff) Google sign-in. `select_account` avoids silent reuse. */
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });
